import React from 'react';
import { Typography } from '@mui/material';
import useStyles from './styles';
import clsx from 'clsx';
import { get } from 'global/lib/lodash';

export const Text = (props) => {
  const { type, bold, italic, center, ...rest } = props;
  const classes = useStyles();
  return <Typography {...rest} className={clsx(get(classes, type), props.className, bold && classes.bold, italic && classes.italic, center && classes.center)} />;
};

export default Text;